<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .language-settings {
    display: flex;
    flex-direction: column;
    padding: 0;
    gap: utils.in_rem(16px);
    align-items: flex-start;
    width: utils.in_rem(520px);

    .section-title {
      @include mixins.h3();
      @include colors.color(textBlack);
    }
  }
</style>

<script>
  import TextToggle from "@sourcewhale/shared/svelte-design-system/components/atoms/Toggles/TextToggle.svelte";
  import { onDestroy } from "svelte";
  import { writable } from "svelte/store";
  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import {
    teamNotetakerSettingsStore,
    teamStore,
  } from "../../../../api-stores/meetings-store";
  import { updateNotetakerLanguageSettings } from "../../../../api/notetaker";
  import { ToastError } from "@sourcewhale/shared/src/svelte/api/sw-toast-error";

  const languageSettingsStore = writable(null);

  const unsubscribe = teamNotetakerSettingsStore.subscribe((settings) => {
    languageSettingsStore.set(settings?.summaryLanguage);
  });

  $: checked = $languageSettingsStore === "English";

  let disabled = false;

  const onToggle = async (enabled) => {
    try {
      disabled = true;
      const res = await updateNotetakerLanguageSettings({
        summaryLanguage: enabled ? "English" : null,
      });
      languageSettingsStore.set(
        res.updateDict.notetakerSettings.summaryLanguage
      );
      showToast({ type: "success", title: "Saved" });
    } catch (error) {
      checked = !enabled;
      if (error instanceof ToastError) {
        showToast(error);
        return;
      }
    } finally {
      teamStore.get();
      disabled = false;
    }
  };

  onDestroy(() => {
    unsubscribe();
  });
</script>

<div class="language-settings">
  <span class="section-title">Language settings</span>
  <TextToggle
    {checked}
    {onToggle}
    {disabled}
    label="Always summarize in English"
  >
    <span slot="description">
      Automatically translate summaries into English when the meeting is
      conducted in another language
    </span>
  </TextToggle>
</div>
